import { connect } from "react-redux";
import { newsletterSelector, newsletterActions } from "./newsletter-reducer";

export function newsletterComposer(Component) {
    const mapStateToProps = function (state) {
        return {
            newsletterSignupPending: newsletterSelector.newsletterSignupPending(state),
            newsletterSettingsSavePending: newsletterSelector.newsletterSettingsSavePending(state)
        };
    };

    const mapDispatchToProps = dispatch => {
        return {
            newsletterSignup: (data, resolve, reject, apiUrl) =>
                dispatch(newsletterActions.newsletterSignup(data, resolve, reject, apiUrl)),
            newsletterSettingsSave: (data, resolve, reject, apiUrl) =>
                dispatch(newsletterActions.newsletterSettingsSave(data, resolve, reject, apiUrl))
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(Component);
}
